export default {"src":"/_next/static/image/public/images/ic_like_empty.421026862ff8a0e2b940075150b1e9ce.svg","height":24,"width":25};